module.exports = __webpack_public_path__ + "img/img_index_banner_hei@2x.0403906f.png";